// API Base URL
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api/v1";

// App Constants
export const APP_NAME = "LICO Admin";
export const APP_VERSION = "1.0.0";

// Pagination
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

// File Upload
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
];

// Date Formats
export const DATE_FORMAT = "MMM DD, YYYY";
export const DATE_TIME_FORMAT = "MMM DD, YYYY HH:mm";

// Status Options
export const CONTACT_STATUS = [
  { value: "open", label: "Open" },
  { value: "closed", label: "Closed" },
];

export const BLOG_STATUS = [
  { value: true, label: "Published" },
  { value: false, label: "Draft" },
];

export const APP_STATUS = [
  { value: true, label: "Published" },
  { value: false, label: "Draft" },
];

// Departments
export const DEPARTMENTS = [
  "general",
  "investors",
  "technology",
  "careers",
  "partnerships",
];

// Admin Roles
export const ADMIN_ROLES = [
  { value: "admin", label: "Admin" },
  { value: "super_admin", label: "Super Admin" },
];

// Blog Categories (sample - adjust based on your needs)
export const BLOG_CATEGORIES = [
  "Technology",
  "Business",
  "Innovation",
  "Training",
  "Solar Energy",
  "Real Estate",
  "Software Development",
];

// App Categories (sample - adjust based on your needs)
export const APP_CATEGORIES = [
  "Productivity",
  "Education",
  "Healthcare",
  "Business",
  "Finance",
  "Utilities",
  "Social",
  "Entertainment",
];

// Sort Options
export const SORT_OPTIONS = [
  { value: "createdAt", label: "Date Created" },
  { value: "updatedAt", label: "Date Updated" },
  { value: "name", label: "Name" },
  { value: "title", label: "Title" },
];

export const SORT_ORDER = [
  { value: "asc", label: "Ascending" },
  { value: "desc", label: "Descending" },
];

// Toast Messages
export const TOAST_MESSAGES = {
  SUCCESS: {
    CREATE: "Created successfully!",
    UPDATE: "Updated successfully!",
    DELETE: "Deleted successfully!",
    COPY: "Copied to clipboard!",
  },
  ERROR: {
    CREATE: "Failed to create. Please try again.",
    UPDATE: "Failed to update. Please try again.",
    DELETE: "Failed to delete. Please try again.",
    FETCH: "Failed to load data. Please try again.",
    NETWORK: "Network error. Please check your connection.",
  },
};

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: "adminToken",
  USER: "adminUser",
  THEME: "theme",
};
